import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex flex-col justify-end overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4c7d13252b5a1ae452c5c8d622153510.jpg"
          alt="IWC Roofing Utah — premium roofing installation"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-charcoal/50 via-charcoal/40 to-charcoal/90"></div>
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/30 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pb-20 pt-32">
        <div className="max-w-4xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-brand-orange text-white text-xs font-body font-700 uppercase tracking-widest px-4 py-2 rounded-full mb-8">
            <i className="ri-map-pin-2-fill"></i>
            Serving Salt Lake City &amp; Northern Utah
          </div>

          {/* H1 */}
          <h1 className="font-heading font-900 text-white uppercase leading-none tracking-tight mb-6">
            <span className="block text-6xl md:text-8xl lg:text-9xl">Utah Roofing</span>
            <span className="block text-6xl md:text-8xl lg:text-9xl text-brand-orange">Done Right</span>
            <span className="block text-3xl md:text-4xl lg:text-5xl font-600 text-white/80 mt-3 normal-case tracking-normal">
              Built to Last. Installed to Perform.
            </span>
          </h1>

          {/* Sub */}
          <p className="font-body text-white/75 text-xl max-w-2xl mb-10 leading-relaxed">
            Residential &amp; Commercial Roofing Experts Serving Salt Lake City and Surrounding Utah Communities. Licensed, Insured &amp; Locally Trusted.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4 mb-12">
            <Link
              to="/#estimate"
              className="flex items-center gap-3 bg-brand-orange hover:bg-brand-orange-dark text-white font-heading font-800 text-lg uppercase tracking-widest px-10 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-check-fill text-xl"></i>
              Get Free Estimate
            </Link>
            <a
              href="tel:+18015550199"
              className="flex items-center gap-3 bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/30 hover:border-white/60 text-white font-heading font-800 text-lg uppercase tracking-widest px-10 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill text-brand-orange text-xl"></i>
              Call Now
            </a>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap items-center gap-6">
            {[
              { icon: 'ri-shield-check-fill', label: 'Licensed & Insured' },
              { icon: 'ri-award-fill', label: '15+ Years Experience' },
              { icon: 'ri-star-fill', label: '4.9★ Rated' },
              { icon: 'ri-map-pin-2-fill', label: 'Utah-Based Crew' },
            ].map((t) => (
              <div key={t.label} className="flex items-center gap-2">
                <i className={`${t.icon} text-brand-orange text-lg`}></i>
                <span className="font-body text-white/80 text-sm font-500">{t.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom Stats Strip */}
      <div className="relative z-10 bg-charcoal/80 backdrop-blur-md border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { num: '1,200+', label: 'Roofs Installed', icon: 'ri-home-3-fill' },
            { num: '15+', label: 'Years Experience', icon: 'ri-calendar-fill' },
            { num: '4.9★', label: 'Customer Rating', icon: 'ri-star-fill' },
            { num: '$0', label: 'Obligation to Estimate', icon: 'ri-price-tag-3-fill' },
          ].map((s) => (
            <div key={s.label} className="flex items-center gap-3">
              <div className="w-10 h-10 flex items-center justify-center bg-brand-orange/20 rounded-lg flex-shrink-0">
                <i className={`${s.icon} text-brand-orange text-lg`}></i>
              </div>
              <div>
                <div className="font-heading font-900 text-white text-xl leading-none">{s.num}</div>
                <div className="font-body text-white/50 text-xs">{s.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
